import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=278002be"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278002be')) {
      api.createRecord('278002be', component.options)
    } else {
      api.reload('278002be', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=278002be", function () {
      api.rerender('278002be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/Wrapper.vue"
export default component.exports